import React from 'react'
import { BrowserRouter, Switch } from 'react-router-dom'
import Route from './Route.react'
let router = (
  <BrowserRouter>
    <Switch>
    <Route
        path={'/drivers/contract'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DriversContractPage/DriversContract.react'))
            },
            'DriversContract'
          )
        }}
      />
    <Route
        path={'/driver-android-beta'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DownloadApkPage/beta/betaDownloadApkPage.react'))
            },
            'betaDownloadApkPage'
          )
        }}
      />
    <Route
        path={'/driver-android'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DownloadApkPage/latest/DownloadApkPage.react'))
            },
            'DownloadApkPage'
          )
        }}
      />
      <Route
        path={'/driver-app'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DriversPage/DriverAppPage.react'))
            },
            'DriverAppPage'
          )
        }}
      />
      <Route
        path={'/food-landing'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/FoodLanding/FoodLanding.react'))
            },
            'FoodLanding'
          )
        }}
      />
      <Route
        exact={true}
        path={'/'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/MainPage/MainPage.react'))
            },
            'MainPage'
          )
        }}
      />
      <Route
        path={'/AP-wallet'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/ApWalletPage/ApWalletPage.react'))
            },
            'ApWalletPage'
          )
        }}
      />
      <Route
        path={'/direct-debit'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/ApLandingPage/ApLandingPage.react'))
            },
            'ApLandingPage'
          )
        }}
      />
      <Route
        path={'/download'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DownloadPage/DownloadPage.react'))
            },
            'DownloadPage'
          )
        }}
      />
      <Route
        path={'/download.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DownloadPage/DownloadPage.react'))
            },
            'DownloadPage'
          )
        }}
      />
      <Route
        path={'/spots'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DownloadPage/DownloadPage.react'))
            },
            'DownloadPage'
          )
        }}
      />
      <Route
        path={'/spots.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DownloadPage/DownloadPage.react'))
            },
            'DownloadPage'
          )
        }}
      />
      <Route
        path={'/career'}
        component={() => {
          window.location = 'https://career.snapp.ir'
        }}
      />
      <Route
        path={'/career.html'}
        component={() => {
          window.location = 'https://career.snapp.ir'
        }}
      />
      <Route
        path={'/career/:jobTag'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/CareerPage/CareerJobPage.react'))
            },
            'CareerJobPage'
          )
        }}
      />
      <Route
        path={'/career.html/:jobTag'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/CareerPage/CareerJobPage.react'))
            },
            'CareerJobPage'
          )
        }}
      />
      <Route
        path={'/about'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/AboutUsPage/AboutUsPage.react'))
            },
            'AboutUsPage'
          )
        }}
      />
      <Route
        path={'/about.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/AboutUsPage/AboutUsPage.react'))
            },
            'AboutUsPage'
          )
        }}
      />
      <Route
        path={'/terms'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/TermsPage/TermsPage.react'))
            },
            'TermsPage'
          )
        }}
      />
      <Route
        path={'/terms.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/TermsPage/TermsPage.react'))
            },
            'TermsPage'
          )
        }}
      />
      <Route
        path={'/box_terms'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/TermsPage/BoxTermsPage.react'))
            },
            'BoxTermsPage'
          )
        }}
      />
      <Route
        path={'/box_terms.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/TermsPage/BoxTermsPage.react'))
            },
            'BoxTermsPage'
          )
        }}
      />
      <Route
        path={'/policy'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/PolicyPage/PolicyPage.react'))
            },
            'PolicyPage'
          )
        }}
      />
      <Route
        path={'/policy.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/PolicyPage/PolicyPage.react'))
            },
            'PolicyPage'
          )
        }}
      />
      <Route
        path={'/contact'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/ContactUsPage/ContactUsPage.react'))
            },
            'ContactPage'
          )
        }}
      />
      <Route
        path={'/contact.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/ContactUsPage/ContactUsPage.react'))
            },
            'ContactPage'
          )
        }}
      />
      <Route
        path={'/landing-mvm'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/LandingMvm.react'))
            },
            'landingMvm'
          )
        }}
      />
      <Route
        path={'/landing-mvm.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/LandingMvm.react'))
            },
            'landingMvm'
          )
        }}
      />
      <Route
        path={'/faq/:type?'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/FAQPage/FaqPage.react'))
            },
            'FaqPage'
          )
        }}
      />
      <Route
        path={'/faq.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/FAQPage/FaqPage.react'))
            },
            'FaqPage'
          )
        }}
      />
      <Route
        exact={true}
        path={'/drivers'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DriversPage/DriversPage.react'))
            },
            'DriversPage'
          )
        }}
      />
      <Route
        exact={true}
        path={'/drivers.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DriversPage/DriversPage.react'))
            },
            'DriversPage'
          )
        }}
      />
      <Route
        path={'/drivers/landing'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/DriversPage/DriversPage.react'))
            },
            'DriversPage'
          )
        }}
      />
      <Route
        exact={true}
        path={'/drivers/education'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/EducationPage/EducationPage.react'))
            },
            'EducationPage'
          )
        }}
      />
      <Route
        path={'/drivers/education/post/:post_tag'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/EducationPage/EducationPostPage.react'))
            },
            'EducationPostPage'
          )
        }}
      />
      <Route
        path={'/drivers/education/category/:category_tag'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/EducationPage/EducationPage.react'))
            },
            'EducationPage'
          )
        }}
      />
      <Route
        path={'/drivers/education/type/:type_tag'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/EducationPage/EducationPage.react'))
            },
            'EducationPage'
          )
        }}
      />
      <Route
        exact={true}
        path={'/drivers/education.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/EducationPage/EducationPage.react'))
            },
            'EducationPage'
          )
        }}
      />
      <Route
        path={'/drivers/promoters/sign_up'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/PromotersPage/SignUpPage.react'))
            },
            'PromotersSignUp'
          )
        }}
      />
      <Route
        exact={true}
        path={'/drivers/promoters/sign_up.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/PromotersPage/SignUpPage.react'))
            },
            'PromotersSignUp'
          )
        }}
      />
      <Route
        path={'/drivers/promoters/verify/:driverId'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/PromotersPage/DriverProfile.react'))
            },
            'DriverProfilePage'
          )
        }}
      />
      <Route
        path={'/drivers/promoters/verify'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/PromotersPage/PromoterPage.react'))
            },
            'PromotersPage'
          )
        }}
      />
      <Route
        exact={true}
        path={'/drivers/promoters/verify.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/PromotersPage/PromoterPage.react'))
            },
            'PromotersPage'
          )
        }}
      />
      <Route
        path={'/drivers/banning/records'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/BanningRecords/BanningRecordsPage.react'))
            },
            'BanningRecordsPage'
          )
        }}
      />
      <Route
        path={'/drivers/banning/records.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/BanningRecords/BanningRecordsPage.react'))
            },
            'BanningRecordsPage'
          )
        }}
      />
      <Route
        exact={true}
        path={'/landings/driver_terms'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/DriverTerms.react'))
            },
            'DriversTerms'
          )
        }}
      />
      <Route
        exact={true}
        path={'/landings/driver_terms.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/DriverTerms.react'))
            },
            'DriversTerms'
          )
        }}
      />
      <Route
        path={'/landings/one'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          return window.open('/landings/rose', '_self')
        }}
      />
      <Route
        path={'/landings/one.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          return window.open('/landings/rose', '_self')
        }}
      />
      <Route
        exact={true}
        path={'/landings/rose'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/OneLanding.react'))
            },
            'OneLandingPage'
          )
        }}
      />
      <Route
        exact={true}
        path={'/landings/rose.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/OneLanding.react'))
            },
            'OneLandingPage'
          )
        }}
      />
      <Route
        exact={true}
        path={'/landings/Kishisland-Contest'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/KishIslandLanding.react'))
            },
            'KishIslandLanding'
          )
        }}
      />
      <Route
        exact={true}
        path={'/landings/Kishisland-Contest.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/KishIslandLanding.react'))
            },
            'KishIslandLanding'
          )
        }}
      />
      <Route
        path={'/landings/Passenger-iOS'}
        component={() => {
          window.location = 'https://ios.snapp.ir/ios-tutorial'
        }}
      />
      <Route
        path={'/open-dlapp'}
        component={() => {
          var userAgent =
            navigator.userAgent || navigator.vendor || window.opera
          setTimeout(function () {
            var query = window.location.search || ''
            window.location = '/download' + query
          }, 100)
          if (/iPad|iPhone|iPod/.test(userAgent)) {
            window.location = 'snapp://open'
          } else if (/android/i.test(userAgent)) {
            window.location = 'snapp://open'
          }
        }}
      />
      <Route
        path={'/landings/:name'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/LandingPage/LandingPage.react'))
            },
            'LandingPage'
          )
        }}
      />
      <Route
        path={'/111'}
        component={() => {
          window.location = 'landings/111'
        }}
      />
      <Route
        path={'/20mil'}
        component={() => {
          window.location = 'landings/20mil'
        }}
      />
      <Route
        path={'/eydi'}
        component={() => {
          window.location = 'landings/4weeksmshdriver'
        }}
      />
      <Route
        path={'/esfand'}
        component={() => {
          window.location = 'landings/4weeksthrdriver'
        }}
      />
      <Route
        path={'/glps'}
        component={() => {
          window.location =
            'https://downloads.snapp.site/android/Google_Play_services/Google_Play_service_v12.6.85.apk'
        }}
      />
      <Route
        path={'/corporate/terms'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/Corporate/CorporateTerms.react'))
            },
            'CorporateTermsPage'
          )
        }}
      />
      <Route
        exact={true}
        path={'/corporate/terms.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/Corporate/CorporateTerms.react'))
            },
            'CorporateTermsPage'
          )
        }}
      />
      <Route
        path={'/corporate/faq'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/Corporate/CorporateFaq.react'))
            },
            'CorporateFaqPage'
          )
        }}
      />
      <Route
        path={'/corporate/faq.html'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/Corporate/CorporateFaq.react'))
            },
            'CorporateFaqPage'
          )
        }}
      />
      <Route
        path={'/ios-tutorial'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/iOSTutorialPage/iOSTutorialPage.react'))
            },
            'iOSTutorialPage'
          )
        }}
      />
      <Route
        path={'/ios-tutorial-2'}
        isSecondIosPage={true}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/iOSTutorialPage/iOSTutorialPage.react'))
            },
            'iOSTutorialPage'
          )
        }}
      />
      <Route
        path={'/jiring'}
        component={() => {
          return (
            <img style={{ width: '100%' }} src='/assets/images/jiring.jpg' />
          )
        }}
      />
      <Route
        path={'/jiring.html'}
        component={() => {
          return (
            <img style={{ width: '100%' }} src='/assets/images/jiring.jpg' />
          )
        }}
      />
      <Route
        path={'/ios/driver/download'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          window.open(
            'itms-services://?action=download-manifest&url=https://downloads.snapp.site/ios/driver/latest/manifest.plist',
            '_self'
          )
        }}
      />
      <Route
        path={'/ios/passenger/download'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          window.open(
            'itms-services://?action=download-manifest&url=https://downloads.snapp.site/ios/passenger/latest/manifest.plist',
            '_self'
          )
        }}
      />
      <Route
        path={'/android/passenger/download'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          window.open(
            'https://downloads.snapp.site/android/passenger/passenger-3.4.5.apk',
            '_self'
          )
        }}
      />
      <Route
        path={'/karaj20'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          window.open('https://snapp.ir/landings/karaj20', '_self')
        }}
      />
      <Route
        path={'/esfahan20'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          window.open('https://snapp.ir/landings/isfahan20', '_self')
        }}
      />
      <Route
        path={'/shiraz20'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          window.open('https://snapp.ir/landings/shiraz20', '_self')
        }}
      />
      <Route
        path={'/4weeks'}
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          window.open('https://snapp.ir/landings/4weeksofesfand', '_self')
        }}
      />
      <Route
        component={() => {
          return <div />
        }}
        getComponent={cb => {
          require.ensure(
            [],
            function (require) {
              cb(require('../Pages/MainPage/MainPage.react'))
            },
            'MainPage'
          )
        }}
      />
    </Switch>
  </BrowserRouter>
);

module.exports = router



// WEBPACK FOOTER //
// ./src/js/components/Router/Router.react.js